$(document).ready(function () {
  $(".c-home-subscribe__button--fragrance").click((el) => {
    $(".c-home-subscribe__fragrance-steps").addClass("active");
    $(".c-home-subscribe__button--fragrance").addClass("active");
    $(".c-home-subscribe__candles-steps").removeClass("active");
    $(".c-home-subscribe__button--candles").removeClass("active");
  });

  $(".c-home-subscribe__button--candles").on("click", (el) => {
    $(".c-home-subscribe__candles-steps").addClass("active");
    $(".c-home-subscribe__button--candles").addClass("active");
    $(".c-home-subscribe__fragrance-steps").removeClass("active");
    $(".c-home-subscribe__button--fragrance").removeClass("active");
  });

  // ---------------------
  // Why mood page
  // ---------------------
  $(".c-why-mood__button--body").on("click", (el) => {
    $(".c-why-mood__button--body").addClass("active");
    $(".c-why-mood--body-content").addClass("active");
    $(".c-why-mood--home-content").removeClass("active");
    $(".c-why-mood__button--home").removeClass("active");
  });

  $(".c-why-mood__button--home").on("click", (el) => {
    $(".c-why-mood__button--home").addClass("active");
    $(".c-why-mood--home-content").addClass("active");
    $(".c-why-mood--body-content").removeClass("active");
    $(".c-why-mood__button--body").removeClass("active");
  });
  // ---------------------
  // ---------------------

  $(".c-mobile-nav__button").click((el) => {
    $(".c-mobile-nav__button").toggleClass("active");
    $(".c-mobile-nav__navigation").toggleClass("active");
  });

  $(".c-modal--trigger").click(function (el) {
    const videoId = $(this).attr("data-videoId");
    $(".c-modal--" + videoId).addClass("active");
  });

  $(".c-modal__close").click(function (el) {
    $(".c-modal").removeClass("active");
  });

  $(".c-mini-cart__bag-clicker").click(function (el) {
    $(".c-mini-cart").toggleClass("active");
  });

  $("html").click(function (el) {
    const container = $(
      ".c-mini-cart__bag-clicker, .c-mini-cart__bag, .c-cart-count"
    );
    if (!container.is(el.target)) {
      $(".c-mini-cart.active").removeClass("active");
    }
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute("href")).scrollIntoView({
        behavior: "smooth",
      });
    });
  });

  $(".c-home-reviews__list").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  });

  $(".c-home-splash__slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    fade: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
  });

  $(".c-latest__list").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".c-product__images-mobile").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });

  $(".c-product__purchase-options-label--subscription").click(function (el) {
    if (!$(el).hasClass("active")) {
      $(".c-product__subscription-discount").addClass("active");
      $("#subInfo").addClass("active");
    }
  });

  $(".c-product__purchase-options-label--single").click(function (el) {
    $(".c-product__subscription-discount").removeClass("active");
    $(".c-product__purchase-options-label--subscription").removeClass(
      "c-product__purchase-options-label--subscription--active"
    );
    $("#subInfo").removeClass("active");
  });

  // if($(".c-product__quantity-value")) {
  //   var qty = $(".c-product__quantity-value").val();
  //   var price = $(".c-product__price-value").text();
  //   console.log(price.replace("£", "") * qty);

  //   $(".c-product__quantity-value").on('change', function() {
  //   console.log('here');
  //   console.log($(this).value());
  //   })
  // }

  $(".c-faqs__item-title").on("click", function () {
    $(this).closest(".c-faqs__item").toggleClass("active");
  });

  // ------------------------
  // Product selection stuff
  // ------------------------

  function hideSubs() {
    const option = $("#productSelect option:selected").attr("data-sku");
    setTimeout(function () {
      $("#productSelect").val($("#productSelect option:first").val()); // HACK: Fixes condition that allows for subs on non subs products
    }, 1);

    if (option === "no-subs") {
      $("#c-product--subs-button").hide();
    } else {
      $("#c-product--subs-button").show();
    }
  }

  hideSubs();

  $(".variantButton").click(function (e) {
    var initialValue = $("#productSelect").val();
    var dataValue = $(this).data("variant");
    var sku = $(this).data("sku");

    if (sku && sku.includes("no-subs")) {
      $("#c-product--subs-button").hide();
      $(".c-product__discount-text").removeClass("active");
      $("#rc_container").hide();
    } else {
      $("#c-product--subs-button").show();
      $("#c-product--single-button input").trigger("click");
      $(".c-product__discount-text").addClass("active");
      $("#rc_container").show();
    }

    if (initialValue != dataValue) {
      $("#subInfo").removeClass("active");
      $(".variantButton").removeClass("active");
      $(this).addClass("active");
      $("select#productSelect").val(dataValue).trigger("change");
    }
  });

  $(".frequencyButton").click(function (e) {
    var initialValue = $(".id-frequency-select").val();
    var dataValue = $(this).data("frequency");
    if (initialValue != dataValue) {
      $(".frequencyButton").removeClass("active");
      $(this).addClass("active");
      $("select.id-frequency-select").val(dataValue).trigger("change");
    }
  });

  $("#productSelect").change(function (e) {
    $("#selected-product-variant").attr("value", e.target.value);
    // Change the images if there's a variant
    // Only works if there's 2 images / variants for now
    const a = $(".c-product--all-images")[0];
    const b = $(".c-product--all-images")[1];

    if (!b) return;

    const aSrc = $(a).attr("src");
    const bSrc = $(b).attr("src");

    $(a).attr("src", bSrc);
    $(b).attr("src", aSrc);

    $(".c-product__images-mobile").slick("slickNext");
  });

  // ---- End product selection stuff

  // Bottom of cart section
  $("#s-cart-description .s-cart__clicker").click(function () {
    const id = $(this).attr("data-id");
    $("#s-cart-description .s-cart__shower").hide();
    $("#s-cart-description ." + id).show();
  });
});
